<template>
  <div class="product-family-head-fi">
    <grid-container-fi :container="false">
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-end-7">
        <catalog-slider-fi
          :catalog-data="catalogData"
          :item-name="familyName"
        />
      </div>
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-7 md:fi-col-end-12">
        <!-- eslint-disable vue/no-v-html -->
        <headline-fi
          v-if="marketingClaim"
          class="product-family-head-fi__marketing-claim fi-mb-12"
          tag="div"
          color="brand"
          :size="30"
        >
          <span v-html="marketingClaim" />
        </headline-fi>
        <headline-fi
          v-if="familyName"
          class="product-family-head-fi__name"
          tag="h1"
          :size="60"
        >
          <span v-html="familyName" />
        </headline-fi>
        <div
          v-if="description"
          class="product-family-head-fi__description"
          v-html="description"
        />
        <!-- eslint-enable vue/no-v-html -->

        <link-fi
          class="product-family-head-fi__link"
          href="#"
          :size="18"
          data-test="product-variants-link"
          @click.stop.prevent="$emit('scrollToVariants')"
        >
          {{ $dict.get('product-Family.Anchor-Link-Text') }}
        </link-fi>

        <link-fi
          v-if="mediaDownloadLink && fields?.mediaDownloadLabel?.value"
          class="product-family-head-fi__link"
          rel="nofollow"
          href="#"
          :size="18"
          @click.stop.prevent="openMediaDownloadDialog"
        >
          {{ fields.mediaDownloadLabel.value }}
        </link-fi>
      </div>

      <media-download-dialog-fi
        ref="mediaDownloadDialog"
        :media-download-link="mediaDownloadLink"
        :file-name="familyName"
        :fields="fields"
      />
    </grid-container-fi>
  </div>
</template>

<script>
import { HeadlineFi, LinkFi } from 'atoms';

import CatalogSliderFi from '@/components/catalog-slider-fi/CatalogSliderFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import MediaDownloadDialogFi from '@/components/product-detail/media-download-dialog-fi/MediaDownloadDialogFi.vue';
import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogTextListMixin from '@/mixins/catalogTextListMixin.vue';

export default {
  name: 'ProductFamilyHeadFi',
  components: {
    CatalogSliderFi,
    GridContainerFi,
    HeadlineFi,
    LinkFi,
    MediaDownloadDialogFi,
  },
  mixins: [breakpointMixin, catalogTextListMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    catalogData: {
      type: Object,
      default: null,
    },
    mediaDownloadLink: {
      type: String,
      default: null,
    },
  },
  emits: ['scrollToVariants'],
  computed: {
    apiFilters() {
      return this.$store.getters['product/apiFilters'];
    },
    marketingClaim() {
      return this.textListValue(this.catalogData.TextList, 'KAT_POS');
    },
    familyName() {
      return this.textListValue(this.catalogData.TextList, 'BEZEICHNUNG');
    },
    description() {
      return this.catalogData?.description;
    },
  },
  methods: {
    openMediaDownloadDialog() {
      this.$refs.mediaDownloadDialog.show();
    },
  },
};
</script>

<style scoped src="./product-family-head-fi" />
